<template>
	<div class="row">
		<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-4" v-if="readonly.finalizado == 0">
			<form ref="form">
                <div class="file mb-2">
                   <input id="filesUp" multiple type="file" ref="files" @change="cargarArchivos" class="file-input" />
                   <p class="call-to-action" v-if="files.length === 0">
                       <i class="fas fa-plus pb-2" style="font-size: 1.6rem"></i><br>
                       Seleccionar o Arrastrar Archivo(s)...
                   </p>
                   <p class="call-to-action" v-if="files.length > 0">
                       <i class="fas fa-copy pb-2" style="font-size: 1.6rem"></i><br>
                       {{ files.length }} Archivo(s) seleccionado(s)...
                   </p>
               </div>
               <div class="w-100 text-right mb-1">
                    <base-button type="danger" size="sm" icon="fa fa-upload" :disabled="btnDisabled" @click="uploadFiles">Cargar</base-button>
               </div>
                <base-alert type="default">
                    <span class="alert-inner--icon"><i class="fa fa-exclamation-triangle"></i></span>
                    <span class="alert-inner--text"><strong> Nota:</strong> El tamaño máximo de adjuntos es 200MB. Máximo de 10 adjuntos por carga.</span>
                </base-alert>
                <base-progress :type="pesoArchivos < 70 ? 'success' : (pesoArchivos >= 70 && pesoArchivos <= 89 ? 'warning' : 'danger')" :height="8" :value="pesoArchivos" :label="size_Files + '/' + Max_size_file + ' (MB)'" :striped="true" :animated="true" :showPercentage="false"></base-progress>

                <div class="errorFiles my-2" v-if="errorUpdFiles.length > 0">
                    <h4 class="mb-2">Error al subir los siguientes archivos: <i class="fas fa-times text-sm float-right" style="cursor:pointer" @click="cerrarMsgError()"></i></h4>
                   <div v-for="(fileError, index) in errorUpdFiles" :key="index">
                       <li>{{ fileError }}</li>
                   </div>
               </div>

                <div class="mt-2">
                   <div v-for="(file, index) in files" :key="index" :class="`level ${file.invalidMessage && 'text-danger'}`">
                        <div class="level-left">
                            <div class="level-item">
                                <i class="fas fa-file"></i> {{file.fileValido.name}} <br>
                                <span v-if="file.invalidMessage" style="font-size: 11px;">({{file.invalidMessage}})</span>
                            </div>
                        </div>
                        <div class="level-right d-flex">
                                <input class="form-control-alternative input-tags" :id="index" placeholder="Etiqueda..." v-if="!file.invalidMessage"></input>
                            <div class="level-item">
                                <i @click.prevent="quitarFiles(index, file)" class="fas fa-times-circle"></i>
                            </div>
                        </div>
                   </div>
               </div>
               <div class="my-2">
                   <p class="messageMaxLong" v-if="messageMaxLong"><i class="fas fa-exclamation-circle"></i> {{ messageMaxLong }} <i class="fas fa-times-circle closeMsg" @click="messageMaxLong=''"></i></p>
               </div>         
            </form>
		</div>
		<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
			<vue-good-table :columns="columns" :rows="allArchivos" :search-options="searchOptions" :pagination-options="paginationOptions" styleClass="vgt-table striped ">
                <template slot="table-row" slot-scope="props">
                    <template v-if="props.column.field === 'actions'">
                        <div class="whitespace-no-wrap">
                            <slot name="table-row-actions" :props="props"></slot>
                            <base-button type="success" size="sm" icon="fa fa-download" @click="submitDownload(props.row)"></base-button>
                            <base-button type="danger" size="sm" icon="fa fa-trash" @click="destroy(props.row.id, props.row)" v-if="deleteFiles.value === 'SI'"></base-button>
                        </div>
                    </template>
                    <slot :name="'table-row-' + props.column.field" :props="props" v-else>{{ props.formattedRow[props.column.field] }}</slot>
                </template>               
            </vue-good-table>
		</div>
        <modal :show.sync="alertWarning">
             <template slot="header">
                <h3 class="modal-title" id="exampleModalLabel"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Advertencia</h3>
             </template>
             <div>
              <p>{{ msgAlertWarning }}</p>
             </div>
             <template slot="footer">
                 <base-button type="secondary" @click="cancelarQuitarArchivosAlertError">Cancelar</base-button>
                 <base-button type="primary" @click="quitarArchivosAlertError">Quitar Archivos</base-button>
             </template>
        </modal>
	</div>
	
</template>

<style lang="scss">
	@import '~vue-good-table/dist/vue-good-table.css';

    .vgt-global-search {
        border: 0 !important;
        background: none !important;

        .vgt-global-search__input {
            @apply p-0;

            .input__icon {
                position: absolute;
                top: 0;
                right: 15px;
                max-width: 32px;
                left: inherit;
            }

            .vgt-pull-left {
                float: right !important;
            }

            .vgt-input {
                width: 50%;
                background-color: #fff;
                border: 0;
                border-bottom: 1px solid #eaeaea!important;
                border-radius: 0;
                -webkit-box-shadow: none;
                box-shadow: none;
                color: #565656;
                height: 30px;
                max-width: 100%;
                padding: 7px 40px 7px 10px;
                -webkit-transition: all 300ms linear 0s;
                transition: all 300ms linear 0s;

                &:focus {
                    -webkit-box-shadow: none;
                    box-shadow: none;
                    border-color: #b7b7b7;
                }

                @screen sm {
                    width: 70%;
                }
                @screen lg {
                    width: 40%;
                }
            }
        }
    }

    .vgt-table {
        border: 0 !important;
        font-size: 14px !important;

        &.striped tbody tr:nth-of-type(odd) {
            @apply bg-grey-lightest;
        }

        thead th {
            @apply border-b bg-grey-light;
            background: none !important;
        }

        tbody td {
            vertical-align: middle !important;
            border-bottom: 0 !important;
        }
    }

    .vgt-wrap__actions-footer {
        @apply border-0 border-b bg-grey-light;
    }

    .vgt-wrap__footer {
        border: 0 !important;
        background: none !important;
    }

    .file {
        min-height: 195px;
        padding: 10px;
        position: relative;
        cursor: pointer;
        outline: 2px dashed #ffffff;
        outline-offset: -10px;
        background: linear-gradient(87deg, #f5365c 0, #f56036 100%) !important;
        color: #ffffff;
        border-radius: 0.375rem;
        -webkit-box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    	box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);

        &:hover {
        	opacity: .9;
        }

        #filesUp {
            height: 222px;
            width: 100%;
            opacity: 0;
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
        }

        .call-to-action {
            font-size: 1.2rem;
            text-align: center;
            padding: 60px 0;
            margin-bottom: 0!important;
        }

        .file-label {
            .file-icon {
                font-size: 18px;
            }
        }

        .button-upload {
            padding: 20px 10px;
            border-radius: 0px 3px 3px 0px;
        }
    }

    .level {
        width: 100%;
        float: left;
        margin: 5px 0;

        .level-left {
            float: left;
        }

        .level-right {
            float: right;

            .input-tags {
                padding: 10px;
                font-size: 14px;
                outline: none;
            }

            .level-item {
                i {
                    font-size: 16px;
                    color: #c0c4cc;
                    cursor: pointer;
                    padding: 14px 10px;

                    &:hover {
                        color: #c32905;
                    }
                }
            }
        }

    }

    .progress-wrapper {
    	padding-top: 0!important;
    }
	
    .errorFiles {
        font-size: 0.875rem;
        color: #a2122f!important;
        background-color: #f75676;
        border-color: #f75676;
        position: relative;
        padding: 1rem;
        border: 1px solid transparent;
        border-radius: 0.375rem;

        h4 {
            color: #a2122f!important;
        }
    }

    .messageMaxLong {
        width: 60%;
        border-left: 3px solid rgba(195, 41, 5, 1);
        padding: 5px;
        background-color: rgba(195, 41, 5, .2);
        font-size: 12px;
        color: #c32905;
        line-height: 15px;

        .closeMsg {
            float: right;
            font-size: 16px;
            cursor: pointer;
        }
    }
</style>

<script>
    import { VueGoodTable } from 'vue-good-table'
    import { mapGetters, mapActions } from 'vuex'
    export default {
        name: "ArchivosMultiples",
        components: {
            VueGoodTable
        },
        props: {
            idobjeto: {
                default: null,
                required: true
            },
            tipoobjeto: {
                default: null,
                required: true
            },
            readonly: {
                type: Object
            }
        },
        data() {
          return {
                valuePagination: {
                    default: 1
                },
                columns: [{
                    label: 'Nombre',
                    field: 'nombre'
                }, {
                    label: 'Etiqueta',
                    field: 'tag'
                }, {
                    label: '',
                    field: 'actions',
                    sortable: false,
                    tdClass: 'vgt-center-align'
                }],
                searchOptions: {
                    enabled: true,
                    placeholder: 'Buscar'
                },
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPage: 10,
                    position: 'bottom',
                    perPageDropdown: [10, 25, 50, 100],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'Siguiente',
                    prevLabel: 'Anterior',
                    rowsPerPageLabel: 'Registros por pág.',
                    ofLabel: 'de',
                    pageLabel: 'pág.',
                    allLabel: 'Todos'
                },
                files: [],
                fileError: [],
                messageMaxLong: '',
                form: {
                    companyname: this.$store.state.auth.company,
                    idobjeto: this.idobjeto,
                    tipoobjeto: this.tipoobjeto,
                    tags: '',
                    file: null,
                    filesize: 0
                },
                message: '',
                error: false,
                pesoArchivos: 0,
                Max_size_file: 200,
                size_files: 0,
                porcentajeArchivos: 0,
                fileSize: 0,
                MAX_SIZE: 20000000 * 10,
                errorUpdFiles: [],
                btnDisabled: false,
                sizeFileCaso: 0,
                porcentFileCaso: 0,
                saveCalculoFileSize: 0,
                alertWarning: false,
                msgAlertWarning: ''
          }
        },
        watch: {
            files: function (val) {
                if (val.length === 0) {
                    document.getElementById('filesUp').value = null
                }

                if (val.length <= 10) {
                    this.btnDisabled = false
                }

                if (this.pesoArchivos > 100 && this.size_Files > 200) {
                    this.btnDisabled = true
                }
            }
        },
        computed: {
            query() {
                return { idobjeto: this.idobjeto, tipoobjeto: this.tipoobjeto }
            },
            size_Files() {
                return this.size_files.toFixed(2)
            },
            deleteFiles() {
                return this.allParametros.data.find(item => item.key === 'CLIENTE_ELIMINAR_ARCHIVO') || {}
            },
            ...mapGetters('auth', { contacto: 'contacto'}),
            ...mapGetters('archivos', { allArchivos: 'all'}),
            ...mapGetters('parametros', { allParametros: 'all'})
        },
        methods: {
            ...mapActions('archivos', ['upload', 'download', 'destroyFile']),
            ...mapActions('archivos', { getAllArchivos: 'getAll' }),
            ...mapActions('parametros', { getAllParametros: 'getAll'}),
            getAll(){
                Promise.all([
                    this.getAllArchivos(this.query),
                    this.getAllParametros({ parametro: 1 })
                ]).then(() => {
                	this.fileSize = 0
                    this.allArchivos.forEach(file => {
                        this.fileSize = this.fileSize + file.filesize
                    })

                    this.sizeFileCaso = (this.fileSize / 1048576)
                    this.size_files = (this.fileSize / 1048576)

                    this.porcentajeArchivos = (this.fileSize / this.MAX_SIZE) * 100

                    this.porcentFileCaso = Math.round(this.porcentajeArchivos)
                    this.pesoArchivos = Math.round(this.porcentajeArchivos)
                })
            },
            cargarArchivos() {
                if (this.saveCalculoFileSize < 1) {
                  this.size_files = this.sizeFileCaso
                  this.pesoArchivos = this. porcentFileCaso
                }
                
                if (this.size_files && this.pesoArchivos) {
                  this.size_files = this.sizeFileCaso
                  this.pesoArchivos = this. porcentFileCaso
                }

                let sizeArchivos = 0;
                let files = [...this.$refs.files.files]

                if (files.length === 0) {
                  this.size_files = 0
                }

                files.forEach(file => {
                    sizeArchivos = sizeArchivos + file.size
                })

                let calculoFileSize = (sizeArchivos / 1048576)

                this.saveCalculoFileSize = calculoFileSize

                this.size_files = (Number(this.size_files) + Number(calculoFileSize))

                let porcentaje = (sizeArchivos / this.MAX_SIZE) * 100

                let calculoPorcentaje = Math.round(porcentaje)

                this.pesoArchivos = (this.pesoArchivos + calculoPorcentaje)

                if (files.length > 10) {
                    this.btnDisabled = true
                    this.msgAlertWarning = 'Excede el máximo de 10 archivos permitidos por carga.'
                    this.alertWarning = true
                } else if (this.pesoArchivos > 100 && this.size_Files > 200) {
                    this.btnDisabled = true
                    this.msgAlertWarning = 'Excede el peso máximo de 200MB.'
                    this.alertWarning = true                    
                } else {
                    this.files = files.map(fileValido => ({
                        fileValido,
                        invalidMessage: this.validate(fileValido)
                    }))
                }
            },
            validate(file) {
                const MAX_SIZE = 20000000
                const typeFiles = ['rar', 'zip', 'ppt', 'pptx', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'txt', 'mp4', 'jpg', 'jpeg', 'png', 'gif', 'svg', 'csv', 'vsdx', 'vsd', 'xlsm']

                if (!typeFiles.includes(file.name.split('.').pop().toLowerCase())) {
                	let messageErrorTypeFile = 'Tipo de archivo no permitido'
                    return messageErrorTypeFile
                }

                return ''
            },
            uploadFiles(event) {
                let arryFilesError = []
                this.subirArchivos(event, (valor) => {
                    arryFilesError.push(valor)
                })

                this.errorUpdFiles = arryFilesError
            },
            subirArchivos(event, callBack) {
                event.preventDefault()
                let listArchivosId = []
                for (let i in this.files) {
                    if (this.files[i].invalidMessage == '') {
                        let tag = document.getElementById(i).value

                        if (!tag) {
                            this.form.tags = this.files[i].fileValido.name
                        } else {
                            this.form.tags = tag
                        }

                        this.form.file = this.files[i].fileValido

                        this.form.filesize = this.form.file.size

                        this.upload({ endpoint: 'uploadfile', dataToSend: this.form })
                            .then((upload) => {
                                if (!upload.id) {
                                	this.$notify({
		                                group: 'foo',
		                                title: 'Mensaje',
		                                type: 'error',
		                                speed: 1000,
		                                duration: 500,
		                                text: upload
		                            });
                                    this.readonly = true
                                } else {
                                    if (upload.id !== 'null') {
                                        if(i == 0){
                                            this.$store.dispatch('notas/custom', {method:'post', endpoint: 'casos/notas/addattached',
                                        dataToSend: {idobjeto: this.idobjeto, tipoobjeto: this.tipoobjeto, idusuario: this.form.idusuario }})
                                            .then(() => {
                                                let params = {
                                                	...this.query
                                                }
                                                this.$store.dispatch('notas/getAll', params)
                                            })
                                        }
                                        let idsFiles = upload.id
                                        listArchivosId.push(idsFiles)
                                        this.$resetData()
                                        // this.$nextTick(() => this.$resetForm('form'))
                                        this.getAll(true)
                                        this.$notify({
			                                group: 'foo',
			                                title: 'Mensaje',
			                                type: 'success',
			                                speed: 1000,
			                                duration: 500,
			                                text: 'Archivo Subido Exitosamente'
			                            });
                                        let ids = this.$store.getters['archivos/archivosUp']
                                        ids.push(upload.id)
                                        this.$store.dispatch('archivos/archivosUp', ids)
                                    } else {
                                    	this.$notify({
			                                group: 'foo',
			                                title: 'Mensaje',
			                                type: 'error',
			                                speed: 1000,
			                                duration: 500,
			                                text: 'Hubo un problema al subir el archivo'
			                            });
                                        callBack(upload.filename)
                                        document.getElementById('filesUp').value = null
                                        this.files = []

                                        let porcentaje = (this.form.filesize / this.MAX_SIZE) * 100
                                        let porcen = Math.round(porcentaje)
                                        this.pesoArchivos = this.pesoArchivos - porcen

                                        let size = (this.form.filesize / 1048576)
                                        this.size_files = (this.size_files - size)
                                    }
                                }
                            })
                            .catch(() => {
                            	this.$notify({
	                                group: 'foo',
	                                title: 'Mensaje',
	                                type: 'error',
	                                speed: 1000,
	                                duration: 500,
	                                text: 'Hubo un problema al subir el archivo'
	                            });
                            })
                    } else {
                        this.fileError.push(file.fileValido)
                    }
                }
            },
            quitarFiles(index, file) {
                this.files.splice(index, 1)

                let porcentaje = (file.fileValido.size / this.MAX_SIZE) * 100
                let porcen = Math.round(porcentaje)
                this.pesoArchivos = this.pesoArchivos - porcen

                let size = (file.fileValido.size / 1048576)
                this.size_files = (this.size_files - size)

                if (this.pesoArchivos < 0) {
                  this.pesoArchivos = 0
                }

                if (this.files.length === 0) {
                  this.size_files = this.sizeFileCaso
                  this.pesoArchivos = this.porcentFileCaso
                }
            },
            cerrarMsgError() {
                this.errorUpdFiles = []
            },
            submitDownload(item) {
                this.download({ endpoint: 'downloadfile', dataToSend: { id: item.id, companyname: this.form.companyname }, name: item.nombre })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            title: 'Mensaje',
                            type: 'error',
                            speed: 1000,
                            duration: 500,
                            text: 'Hubo un problema al descargar el archivo.'
                        });
                    })
            },
            destroy(id, file) {
                return this.destroyFile({id})
                .then((data) => {
                    let params = {
                        ...this.query
                    }
                    this.$notify({
                        group: 'foo',
                        title: 'Mensaje',
                        type: 'success',
                        speed: 1000,
                        duration: 500,
                        text: 'Archivo Eliminado Exitosamente'
                    });
                    this.$store.dispatch('notas/getAll', params)

                    let porcentaje = (file.filesize / this.MAX_SIZE) * 100
                    let porcen = Math.round(porcentaje)
                    this.pesoArchivos = this.pesoArchivos - porcen

                    let size = (file.filesize / 1048576)
                    this.size_files = (this.size_files - size)
                    this.getAll()
                }).catch(() => {
                    this.$notify({
                        group: 'foo',
                        title: 'Mensaje',
                        type: 'error',
                        speed: 1000,
                        duration: 500,
                        text: 'Hubo un problema al eliminar el archivo.'
                    });
                })
            },
            quitarArchivosAlertError() {
                 let files = [...this.$refs.files.files]
                this.files = files.map(fileValido => ({
                    fileValido,
                    invalidMessage: this.validate(fileValido)
                }))
                this.alertWarning = false
            },
            cancelarQuitarArchivosAlertError() {
                document.getElementById('filesUp').value = null
                this.size_files = this.sizeFileCaso
                this.pesoArchivos = this.porcentFileCaso
                this.files = []
                this.alertWarning = false
            }
        },
        mounted() {
            this.getAll(true)
        }
    }	
</script>
